import { DialogCloseEvent, DialogOpenEvent } from '@theme/dialog';
import { debounce } from '@theme/utilities';

function syncSearchModalLayout() {
  const dialog = document.querySelector('#search-modal dialog.search-modal__content');
  const header = document.querySelector('#header-component');
  const formHeader = dialog?.querySelector('.predictive-search-form__header');

  if (!dialog || !header) return;

  const { top, height } = header.getBoundingClientRect();
  const topPx = Math.max(0, Math.round(top));
  const heightPx = Math.max(0, Math.round(height));

  dialog.style.setProperty('--search-modal-top', `${topPx}px`);

  if (formHeader && heightPx > 0) {
    formHeader.style.minHeight = `${heightPx}px`;
  }
}

function clearSearchModalLayout() {
  const dialog = document.querySelector('#search-modal dialog.search-modal__content');
  const formHeader = dialog?.querySelector('.predictive-search-form__header');

  dialog?.style.removeProperty('--search-modal-top');
  formHeader?.style.removeProperty('min-height');
}

function initSearchModalLayout() {
  const modal = document.querySelector('#search-modal');
  const dialog = modal?.querySelector('dialog.search-modal__content');

  if (!modal || !dialog) return;

  modal.addEventListener(DialogOpenEvent.eventName, () => {
    requestAnimationFrame(syncSearchModalLayout);
  });

  modal.addEventListener(DialogCloseEvent.eventName, clearSearchModalLayout);

  window.addEventListener(
    'resize',
    debounce(() => {
      if (dialog.open) syncSearchModalLayout();
    }, 100)
  );
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initSearchModalLayout, { once: true });
} else {
  initSearchModalLayout();
}
